import MaintenancesTable from './MaintenancesTable'
export default MaintenancesTable
